/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  AppControllerRedirectToMobileAppQueryResponse,
  AppControllerRedirectToMobileApp404,
} from '../types/AppControllerRedirectToMobileApp.ts';

function getAppRedirectToMobileAppUrl() {
  const res = { method: 'GET', url: `/api/mobile-app` as const };
  return res;
}

/**
 * {@link /api/mobile-app}
 */
export async function appRedirectToMobileApp(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    AppControllerRedirectToMobileAppQueryResponse,
    ResponseErrorConfig<AppControllerRedirectToMobileApp404>,
    unknown
  >({ method: 'GET', url: getAppRedirectToMobileAppUrl().url.toString(), ...requestConfig });
  return res.data;
}
